<template>
  <div>

    <!-- //FILTRO -->
    <div
      class="row"
      v-if="!list"
    >
      <div
        class="col-md-12 col-xs-12"
        style="flex-wrap: wrap; margin-bottom: 20px"
      >
        <div class="text-right">
          <btn-rounded
            class="text-right"
            :label="filter ? 'LIMPAR' : 'FILTRO'"
            event="showFilter"
            :active-color="filter ? 'danger' : 'primary'"
          />
        </div>

      </div>

      <div
        v-if="filter"
      >
        <div
          class="row"
          style="padding: 20px"
          text-center
        >
        <div class="col-md-4">
            <fg-input
              type="text"
              label="Busca"
              placeholder="Nome, Email..."
              v-model="filterOptions.term"
            />
          </div>
         
          <div class="col-md-2">
            <fg-input
              type="date"
              label="Data de criação Inicial"
              :max="filterOptions.intervalEnd"
              v-model="filterOptions.intervalStart"
            />
          </div>

          <div class="col-md-2">
            <fg-input
              type="date"
              label="Data de criação Final"
              :min="filterOptions.intervalStart"
              v-model="filterOptions.intervalEnd"
            />
          </div>

        </div>

        <div
          class="row"
          style="margin-bottom: 20px"
        >
          <div class="col-md-12" style="flex-wrap: wrap;">
            <div class="text-right">
              <btn-rounded
                class="text-right"
                label="FILTRAR"
                event="activeFilter"
                active-color="success"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- FILTRO// -->
    
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <component-table
            eventName="selectItem"
            :title="table.title"
            :sub-title="table.subTitle"
            :data="list || userPendinglist"
            :columns="table.columns"
            :headers="table.headers"
            :buttonsConfirm="table.buttons"

          />
        </div>
      </div>
    </div>
    <v-dialog />
  </div>
</template>

<script>
  import ComponentTable from "components/UIComponents/Lists/ComponentTable.vue";
  import {mapActions, mapState, mapGetters} from "vuex";
  import moment from 'moment';
  const headers = ["Nome","Email", "Telefone", "Data Cadastro", "Status",  "Aprovar"];
  const tableColumns = [
    "name", "email", "formattedPhone",

    {
      columnName: "createdAt",
      logic: function (data, columnData) {
        if (!data) {
          return ''
        }
        return moment.utc(data).utcOffset(-180).format('D/M/YYYY H:mm:ss');
      }
    },
    {
      columnName: "isApproved",
      logic: function (data) {
        let className = 'text-danger';
        let val = 'Aguardando';
        if (data) {
          className = 'text-success';
          val = 'Aprovado';
        }
        let prefix = `<span class="${className}" style="font-size:large">&bullet;</span>`;

        return `${prefix} ${val}`
      }
    }
  ];
  const buttons = [{
    event: "approveUser",
    icon: "/static/img/confirm.png",
    class: "",
    tooltip: "Aprovar Lojistas"
  },
  {
    event: "rejectUser",
    icon: "/static/img/cancel.png",
    class: "",
    tooltip: "Recusar Compradaores"
  }];


  export default {
    components: {
      ComponentTable
    },

    props: {
      list: {
        type: Array,
        default: () => {
          return null;
        }
      }
    },

    computed: {
      ...mapState({
        userPendinglist: ({user}) => user.toValidateList,
      }),
      ...mapGetters({
        sidebarFlag: 'sidebarFlag'
      })
    },

    methods: {
      ...mapActions(["getUserToValidateList", "approveUser", "reproveUser"]),
    
      setPage: function (page) {
        this.page = page;
      },
      
      cleanFilter() {
        for (let idx in this.filterOptions) {
          this.filterOptions[idx] = undefined;
        }
        // this.filterOptions.intervalStart = moment().startOf('month').format('YYYY-MM-DD');
        // this.filterOptions.intervalEnd = moment().endOf('month').format('YYYY-MM-DD');
        this.initData();
      },

      initData() {
        if(this.$route.params){
        this.filterOptions.isAdmin = this.$route.params.isAdmin;
        }

        if (!this.list) {    
          return this.getUserToValidateList(this.filterOptions).then(res=>{

          });
        }
       
        return Promise.resolve({})
      }
    },

    created() {
      this.cleanFilter();
      this.$on("novo", () => {
        this.$router.push("/admin/usuarios/criar");

      });
      this.$on("selectItem", item => {
        this.$modal.show('dialog', {
          title: 'Direcionamento',
          text: 'Deseja realmente entrar na alteração cadastral desse lojista?',
          buttons: [{
              title: 'Sim',
              handler: () => {

                this.$router.push({
                name: "Usuários - Editar",
                params: {id: item}
                
              });

                 this.$modal.hide('dialog')

              }
            },
            {
              title: 'Não', // Button title
              handler: () => {
                    
                this.$modal.hide('dialog')
              } // Button click handler
            }

          ]
        });   
       
      });
      this.$on("showFilter", () => {
        if (this.filter) this.cleanFilter();
        this.filter = !this.filter;
      });
      this.$on("activeFilter", () => {
        if (!!this.filterOptions.term && this.filterOptions.term.length < 3) {
          return this.$notify({
            group: "foo",
            title: "Busca invalida",
            text: "Minímo de 3 caracteres",
            position: "top center",
            type: "error",
          });
        }
        this.initData();
        // this.filter = !this.filter;
      });

      this.$on("approveUser", item => {
        this.$modal.show('dialog', {
          title: 'Atualizar status de Vendedores',
          text: 'Deseja ativar o cadastro deste usuário com acesso de lojista?',
          buttons: [{
              title: 'Sim',
              handler: () => {

                   item.isApproved = true
                

              this.approveUser({"UserId": item.id, "isApproved": item.isApproved})
                .then(res => {
                  this.$notify({
                    group: "foo",
                    title: "Sucesso",
                    text: "Status de lojista alterado com sucesso",
                    position: "top center",
                    type: "success"
                  });
                  this.initData()

                })
                .catch(res => {
                  this.$notify({
                    group: "foo",
                    title: res.msg,
                    text: res.info,
                    position: "top center",
                    type: "error"
                  });
                });
                 this.$modal.hide('dialog')

              }
            },
            {
              title: 'Não', // Button title
              handler: () => {
                    
                this.$modal.hide('dialog')
              } // Button click handler
            }

          ]
        });   
      
      });


       this.$on("rejectUser", item => {        
        this.$modal.show('dialog', {
          title: 'Atualizar status de lojista',
          text: 'Deseja desativar o cadastro deste usuário removendo o acesso de lojista?',
          buttons: [{
              title: 'Sim',
              handler: () => {

                   item.isApproved = false
                

              this.reproveUser({"UserId": item.id, "isApproved": item.isApproved})
                .then(res => {
                  console.log(res)
                  this.$notify({
                    group: "foo",
                    title: "Sucesso",
                    text: "Status de Lojista alterado com sucesso",
                    position: "top center",
                    type: "success"
                  });
                  this.initData()
                })
                .catch(res => {

                });
                
                this.$modal.hide('dialog')

              }

            },
            {
              title: 'Não', // Button title
              handler: () => {
                    
                this.$modal.hide('dialog')
              } // Button click handler
            }

          ]
        }); 
        
      });
    },

    data() {
      return {
        page: 1,
          table: {
          title: "Lojistas",
          subTitle: "Lista de Lojistas cadastrados",
          headers: [...headers],
          columns: [...tableColumns],
          buttons: [...buttons],
        },
        filter: false,
        filterOptions: {
          isAdmin: undefined,
          isActive: undefined,
          term: undefined,
          intervalStart: undefined,
          intervalEnd: undefined,
 
        },
        adminList: [
          {
            value: true,
            name: "Admin"
          },
          {
            value: false,
            name: "não Admin"
          }
        ],
        activeList:[
          {
            value: true,
            name: "Ativo"
          },
          {
            value: false,
            name: "Não Ativo"
          }
        ],
       
      };
    },

  };
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Industries/IndustriesList.vue